import { getSiteSettingsApiConfig } from '@gn-audio/core/api/site-settings/config/actions';
export var getSiteContext = function () {
    return getSiteSettingsApiConfig().siteContext;
};
